import { createContext, useContext, useEffect, useState } from "react";
import {
  getExlusifsPost,
  getPopularsPost,
  getPosts,
  getRecentsPost,
} from "../services/PostServices";
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_BACKEND_URL}`;

const PostContext = createContext();

export default function PostProvider({ children }) {
  const [posts, setPosts] = useState([]);
  const [recents, setRecents] = useState([]);
  const [populars, setPopulars] = useState([]);
  const [exclusifs, setExclusifs] = useState([]);

  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const updatePost = (id, updatedData) => {
    setPosts((prevPosts) =>
      prevPosts.map((post) =>
        post.id === id ? { ...post, ...updatedData } : post
      )
    );
  };

  const deletePost = (id) => {
    setPosts((prevPosts) => prevPosts.filter((post) => post.id !== id));
  };

  // CRUD Functions
  const createPost = (newPost) => {
    setPosts((prevPosts) => [...prevPosts, { ...newPost, id: Date.now() }]);
  };

  // Search for Movie or TV by Keyword
  const searchPosts = async (params) => {
    const resp = await axios.get(`${apiUrl}/api/posts/search?${params}`);
    return resp.data;
  };

  const getData = () => {
    return Promise.all([
      getPosts(),
      getRecentsPost(),
      getPopularsPost(),
      getExlusifsPost(),
    ]);
  };

  useEffect(() => {
    getData()
      .then(
        ([postsData, recentPostData, popularPostsData, exclusifsPostData]) => {
          setPosts(postsData);
          setRecents(recentPostData);
          setPopulars(popularPostsData);
          setExclusifs(exclusifsPostData);
        }
      )
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoaded(true);
      });
  }, []);

  return (
    <PostContext.Provider
      value={{
        posts,
        recents,
        populars,
        exclusifs,
        error,
        loaded,
        createPost,
        deletePost,
        updatePost,
        searchPosts
      }}
    >
      {children}
    </PostContext.Provider>
  );
}

export function usePost() {
  return useContext(PostContext);
}
